import DesktopTransferPanel from '../desktop/DesktopTransferPanel';
import React, { useState, useEffect } from 'react';
import { Modal } from 'semantic-ui-react';
import { ethers } from 'ethers';
import CryptoMoneyPanel from '../shared/crypto/CryptoMoneyPanel';
import { trackPageRequest } from '../shared/PageLoadingService';

const walletStyles = `
.tbp-mobile-wallet-trigger {
    position: fixed; right: 16px; bottom: calc(18px + env(safe-area-inset-bottom));
    z-index: 99999; display: flex; align-items: center; gap: 9px;
    min-height: 48px; padding: 12px 18px; border: 0; border-radius: 24px;
    background: #484d54; color: white; font: 600 16px Lato, Arial, sans-serif;
    box-shadow: 0 4px 16px rgba(0,0,0,.25); cursor: pointer;
}
.tbp-mobile-wallet-trigger i { margin: 0 !important; font-size: 20px; }
.ui.modal.tbp-mobile-wallet {
    --wallet-text: #171717; --wallet-bg: #e0e1e2; --wallet-surface: #eee;
    position: relative !important; width: 100% !important; max-width: 100% !important;
    margin: 0 !important; border-radius: 0 !important; padding: 0 !important;
    background: var(--wallet-bg) !important; color: var(--wallet-text) !important;
    min-height: 100vh; min-height: 100dvh; box-shadow: none !important;
    font: 400 16px/1.5 Lato, Arial, sans-serif;
}
.ui.modal.tbp-mobile-wallet.dark {
    --wallet-text: #fff; --wallet-bg: #282c34; --wallet-surface: #3e4349;
}
.tbp-mobile-wallet * { box-sizing: border-box; }
.tbp-mobile-wallet .wallet-header {
    display: flex; align-items: center; justify-content: space-between; gap: 16px;
    padding: calc(16px + env(safe-area-inset-top)) 20px 16px;
    border-bottom: 1px solid rgba(128,128,128,.25);
}
.tbp-mobile-wallet .wallet-heading { margin: 0; font: 600 22px/1.3 Lato, Arial, sans-serif; color: inherit; }
.tbp-mobile-wallet .wallet-brand { margin: 0 0 4px; font-size: 13px; }
.tbp-mobile-wallet .wallet-close {
    min-width: 48px; min-height: 48px; padding: 8px; border: 0; border-radius: 5px;
    background: var(--wallet-surface); color: var(--wallet-text); font: inherit; cursor: pointer;
}
.tbp-mobile-wallet .wallet-balance { margin: 0; padding: 20px; background: var(--wallet-surface); }
.tbp-mobile-wallet .wallet-balance span { display: block; font-size: 14px; }
.tbp-mobile-wallet .wallet-balance strong { display: block; margin: 4px 0; font-size: 28px; line-height: 1.3; }
.tbp-mobile-wallet .wallet-balance small { font-size: 13px; font-weight: 400; }
.tbp-mobile-wallet .wallet-tabs { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); padding: 16px 16px 0; gap: 6px; }
.tbp-mobile-wallet .wallet-tabs button {
    min-height: 48px; padding: 12px 4px; margin: 0; border: 0; border-radius: 5px 5px 0 0;
    background: transparent; color: var(--wallet-text); font: 600 15px Lato, Arial, sans-serif; cursor: pointer;
}
.tbp-mobile-wallet .wallet-tabs button[aria-selected="true"] { background: var(--wallet-surface); }
.tbp-mobile-wallet .wallet-content { background: var(--wallet-surface); padding: 0 0 calc(24px + env(safe-area-inset-bottom)); }
.tbp-mobile-wallet .tbp-crypto { height: auto !important; max-height: none !important; overflow: visible !important; padding: 24px 20px; background: transparent; }
.tbp-mobile-wallet .tbp-crypto h3 { font-size: 22px; margin-bottom: 16px; }
.tbp-mobile-wallet .tbp-crypto p { font-size: 16px; line-height: 1.6; }
.tbp-mobile-wallet .tbp-crypto .note { font-size: 14px; }
.tbp-mobile-wallet .tbp-crypto .hash { font-size: 15px; line-height: 1.6; }
.tbp-mobile-wallet .tbp-crypto label { font-size: 16px; margin-top: 24px; }
.tbp-mobile-wallet .tbp-crypto input,
.tbp-mobile-wallet .tbp-crypto button { min-height: 48px; font-size: 16px; }
.tbp-mobile-wallet .tbp-crypto .card { padding: 16px; margin-top: 20px; }
.tbp-mobile-wallet .wallet-transfer { padding: 24px 20px; }
.tbp-mobile-wallet .wallet-transfer h3 { margin: 0 0 16px; font-size: 22px; color: inherit; }
.tbp-mobile-wallet .wallet-transfer label { display: block; margin: 24px 0 8px; font-weight: 600; }
.tbp-mobile-wallet .wallet-transfer input {
    width: 100%; min-height: 48px; padding: 14px; border: 1px solid #888; border-radius: 5px;
    background: var(--wallet-bg); color: inherit; font: 400 16px Lato, Arial, sans-serif;
}
.tbp-mobile-wallet .wallet-transfer button {
    width: 100%; min-height: 48px; margin-top: 24px; padding: 14px; border: 0; border-radius: 5px;
    background: #484d54; color: white; font: 600 16px Lato, Arial, sans-serif; cursor: pointer;
}
.tbp-mobile-wallet .wallet-transfer button:disabled { opacity: .5; cursor: default; }
.tbp-mobile-wallet .wallet-transfer p { margin: 16px 0; overflow-wrap: anywhere; }
.tbp-mobile-wallet .wallet-error { color: #fc5d5d; }
.tbp-mobile-wallet :focus-visible { outline: 2px solid #009e81; outline-offset: 3px; }
@media (max-width: 767px) {
    .ui.modal.tbp-crypto-modal { font-size: 16px; }
    .ui.modal.tbp-crypto-modal input { font-size: 16px; min-height: 48px; }
    .ui.modal.tbp-crypto-modal button { min-height: 48px; font-size: 16px; }
}

/* v36: inherit the page theme for the floating wallet trigger. */
.tbp-mobile-wallet-trigger.tbp-mobile-wallet-trigger--light {
    background: #ffffff; color: #172c43; border: 1px solid #c9d9e6;
    box-shadow: 0 8px 22px rgba(23, 44, 67, .13);
}
.tbp-mobile-wallet-trigger.tbp-mobile-wallet-trigger--dark {
    background: #13243a; color: #f0f6fc; border: 1px solid #3b526b;
    box-shadow: 0 10px 28px rgba(2, 15, 26, .25);
}
.tbp-mobile-wallet-trigger.tbp-mobile-wallet-trigger--light i { color: #078d74; }
.tbp-mobile-wallet-trigger.tbp-mobile-wallet-trigger--dark i { color: #19c8a3; }

/* Consistent wallet presentation matching Welcome, no state/action changes. */
.tbp-mobile-wallet-trigger {background:#13243a; color:#e9f5fb; border:1px solid rgba(154,189,212,.22); border-radius:11px; box-shadow:0 10px 28px rgba(2,15,26,.25); font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Inter,Lato,sans-serif;}
.tbp-mobile-wallet-trigger i {color:#19c8a3;}
.ui.modal.tbp-mobile-wallet {
 --wallet-bg:#eef4f8; --wallet-surface:#e6eff5; --wallet-text:#20364a;
 font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Inter,Lato,sans-serif;
 border-radius:0 !important;
}
.ui.modal.tbp-mobile-wallet.dark {--wallet-bg:#0d1725;--wallet-surface:#16253a;--wallet-text:#f0f6fc;}
.tbp-mobile-wallet .wallet-header {background:var(--wallet-bg); border-bottom:1px solid rgba(140,169,190,.2);}
.tbp-mobile-wallet .wallet-brand {color:#079e82; text-transform:uppercase; letter-spacing:.12em; font-size:10px; font-weight:800;}
.tbp-mobile-wallet .wallet-heading {font-weight:760; letter-spacing:-.035em;}
.tbp-mobile-wallet .wallet-close {background:var(--wallet-surface); border:1px solid rgba(130,155,180,.18); border-radius:8px; font-weight:650;}
.tbp-mobile-wallet .wallet-balance {background:var(--wallet-surface); border-bottom:1px solid rgba(130,155,180,.18);}
.tbp-mobile-wallet .wallet-balance span,.tbp-mobile-wallet .wallet-balance small {opacity:.76;}
.tbp-mobile-wallet .wallet-tabs {background:var(--wallet-bg);padding:12px 16px 0;gap:0;}
.tbp-mobile-wallet .wallet-tabs button {border-radius:0 !important; min-width:0; font-weight:650; border-bottom:2px solid transparent;}
.tbp-mobile-wallet .wallet-tabs button[aria-selected="true"] {background:var(--wallet-surface);border-bottom-color:#13b995;color:var(--wallet-text);}
.tbp-mobile-wallet .wallet-content {background:var(--wallet-surface);}
.tbp-mobile-wallet .wallet-transfer {background:var(--wallet-surface);}
.tbp-mobile-wallet .wallet-transfer input {background:var(--wallet-bg);border:1px solid rgba(132,158,181,.25);border-radius:8px;}
.tbp-mobile-wallet .wallet-transfer button {background:#0da283;color:white;border-radius:8px;}
`;

export default function MobileWalletPanel({ page, publicKey, web3 }) {
    const state = page.state;
    const spanish = state.selectedLanguage === 'spanish';
    const text = (english, spanishText) => spanish ? spanishText : english;
    const [mode, setMode] = useState('deposit');
    const [transferError, setTransferError] = useState('');
    const [visited, setVisited] = useState({ deposit: true });
    const [processingNotice, setProcessingNotice] = useState('');

    useEffect(() => {
        if (state.moneyTransferOverlay) setTransferError('');
    }, [state.moneyTransferOverlay]);

    let balance = '—';
    try {
        if (state.walletBalanceWei != null) {
            balance = Number(ethers.utils.formatEther(String(state.walletBalanceWei)))
                .toLocaleString(spanish ? 'es-US' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    } catch (error) {
        // Keep an unavailable balance distinct from a zero balance.
    }

    function allowNavigation() {
        if (document.querySelector('.tbp-mobile-wallet .spinner')) {
            setProcessingNotice(text('Please wait for the current action to finish.', 'Espera a que termine la acción actual.'));
            return false;
        }
        setProcessingNotice('');
        return true;
    }

    function closeWallet() {
        if (allowNavigation()) page.setState({ moneyTransferOverlay: false });
    }

    function refreshBalance() {
        if (publicKey && web3) {
            trackPageRequest(web3.eth.getBalance(publicKey)).then(balanceWei => {
                page.setState({ walletBalanceWei: balanceWei, walletBalanceUSD: Number(balanceWei) / 1e18 });
            }).catch(() => {});
        }
    }

    function reviewTransfer(event) {
        event.preventDefault();
        const recipient = String(page.state.destinationUsername || '').trim();
        const amount = String(page.state.moneyTransactionLiveValue || '').trim();
        try {
            if (!recipient || !ethers.utils.parseEther(amount).gt(0)) throw new Error('Invalid transfer');
            if (ethers.utils.parseEther(amount).gte(ethers.BigNumber.from(String(page.state.walletBalanceWei || '0')))) {
                setTransferError(text('Choose an amount below your available balance to leave room for network fees.', 'Elige un importe menor que tu saldo para reservar fondos para los costos de red.'));
                return;
            }
        } catch (error) {
            setTransferError(text('Enter a recipient username and a valid amount.', 'Ingresa el usuario de destino y un importe válido.'));
            return;
        }
        setTransferError('');
        page.setState({
            moneyTransferOverlay: false,
            moneyTransactionPreset: 'transfer',
            destinationUsername: recipient,
            passwordText: '',
            transactionConfirmationMessage: text(
                `Send ${amount} USD to ${recipient.toUpperCase()}?`,
                `¿Enviar ${amount} USD a ${recipient.toUpperCase()}?`
            ),
            showPasswordOverlay: true
        });
    }

    const modes = [
        ['deposit', text('Deposit', 'Depositar')],
        ['transfer', text('Send', 'Enviar')],
        ['withdraw', text('Withdraw', 'Retirar')]
    ];

    return <>
        <style>{walletStyles}</style>
        <button
            type="button"
            className={'tbp-mobile-wallet-trigger tbp-mobile-wallet-trigger--' + (state.mode_light_dark === 'light' ? 'light' : 'dark')}
            aria-haspopup="dialog"
            aria-expanded={Boolean(state.moneyTransferOverlay)}
            onClick={() => page.setState({ moneyTransferOverlay: true })}
        >
            <i className="exchange icon" aria-hidden="true" />
            {text('Wallet', 'Cartera')}
        </button>

        <Modal
            open={Boolean(state.moneyTransferOverlay)}
            centered={false}
            className={'tbp-mobile-wallet ' + (state.mode_light_dark === 'light' ? 'light' : 'dark')}
            onClose={closeWallet}
            closeOnDimmerClick={false}
            aria-label={text('Blender Wallet', 'Cartera Blender')}
        >
            <header className="wallet-header">
                <div>
                    <p className="wallet-brand">The Blender Platform</p>
                    <h2 className="wallet-heading">{text('Blender Wallet', 'Cartera Blender')}</h2>
                </div>
                <button type="button" className="wallet-close" onClick={closeWallet}>
                    {text('Close', 'Cerrar')}
                </button>
            </header>
            <p className="wallet-balance">
                <span>{text('Available Balance:', 'Saldo Disponible:')}</span>
                <strong>{balance} USD</strong>
                <small>{text('USD equivalent held in xDAI.', 'Equivalente en USD mantenido en xDAI.')}</small>
            </p>
            <div className="wallet-tabs" role="tablist" aria-label={text('Wallet Actions', 'Acciones de la Cartera')}>
                {modes.map(([id, label]) => <button key={id} type="button" role="tab" id={'wallet-tab-' + id}
                    aria-selected={mode === id} aria-controls={'wallet-panel-' + id}
                    onClick={() => { if (allowNavigation()) { setMode(id); setVisited(previous => ({ ...previous, [id]: true })); setTransferError(''); } }}>{label}</button>)}
            </div>
            <div className="wallet-content">
                {processingNotice && <p role="status" style={{ padding: 20, margin: 0 }}>{processingNotice}</p>}
                {['deposit', 'withdraw'].map(id => <div key={id} hidden={mode !== id} role="tabpanel"
                    id={'wallet-panel-' + id} aria-labelledby={'wallet-tab-' + id}>
                    {visited[id] && <CryptoMoneyPanel mode={id} theme={state.mode_light_dark}
                        language={state.selectedLanguage} balanceWei={state.walletBalanceWei} onComplete={refreshBalance} />}
                </div>)}
                {mode === 'transfer' && <div role="tabpanel" id="wallet-panel-transfer" aria-labelledby="wallet-tab-transfer" className="wallet-transfer wallet-transfer--redesigned">
                    <DesktopTransferPanel mobile
                        language={state.selectedLanguage}
                        theme={state.mode_light_dark}
                        amount={state.moneyTransactionLiveValue || ''}
                        recipient={state.destinationUsername || ''}
                        usernames={state.allUserUsernamesDisplayNames || []}
                        balanceWei={state.walletBalanceWei}
                        commissionRate={state.transferCommissionPercentDecimal}
                        onAmountChange={value => page.setState({moneyTransactionLiveValue: value})}
                        onRecipientChange={value => page.setState({
                            destinationUsername: value,
                            activeSearchTransferBool: String(value).length >= 2,
                            showSearchDropDownMenuBool: String(value).length >= 2
                        })}
                        onContinue={(username, value) => {
                            page.setState({destinationUsername: username, moneyTransactionLiveValue: String(value)}, () => reviewTransfer({preventDefault() {}}));
                        }}
                    />
                    <p className="tbp-wallet-transfer-network-note">{text('Network fees are additional.', 'Los costos de red son adicionales.')}</p>
                    {transferError && <p role="alert" className="wallet-error">{transferError}</p>}
                </div>}
            </div>
        </Modal>
    </>;
}
